import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CommissionTypesFeatureKey, CommissionTypeState, selectAllCommissionType, selectCommissionTypeEntities, selectCommissionTypeFetched } from '../reducers/commissionType.reducer';

const selectState = createFeatureSelector<CommissionTypeState>(CommissionTypesFeatureKey);

export const getCommissionTypeDictionary = createSelector(selectState, selectCommissionTypeEntities);
export const getCommissionTypesFetched = createSelector(selectState, selectCommissionTypeFetched);
export const getCommissionTypes = createSelector(selectState, selectAllCommissionType);
export const getCommissionTypeById = (props: { id: number }) => createSelector(getCommissionTypeDictionary, (array) => props.id && array[props.id]);
